import { MSConstant } from '@/commons/wildcards';
import { getCurrentInstance } from 'vue';
/**
 * Xử lý control kỳ tính, từ ngày, đến ngày
 */
class SummaryUtil {
  /**
   * Thực hiện theo công thức được cấu hình tại cấu hình cột
   * @param {String} command: công thức
   * @param {String} field: cột
   * @param {Number} dataFormat: kiểu dữ liệu của cột
   * @author NVLAM 24.09.2020
   */
  doFunction(data, command, field, dataFormat, totalCount) {
    let me = this,
      result;
    switch (command) {
      case MSConstant.SummaryType.Sum:
        result = me.sumField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.SumAll:
        result = me.sumAllField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.Min:
        result = me.minField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.Max:
        result = me.maxField(data, field, dataFormat);
        break;
      case MSConstant.SummaryType.RowCount:
        result = me.rowCount(totalCount);
        break;
    }
    return result;
  }

  /**
   * Tính sum
   * NCPHUOC 07/09/2022: Thực hiện làm tròn nếu format là amount
   */
  sumField(data, field, dataFormat) {
    let me = this,
      sum = 0;
    data.forEach(item => {
      if (item[field]) {
        if (dataFormat === MSConstant.FormatType.Amount || dataFormat === MSConstant.FormatType.ComboboxAmount) {
          sum += parseFloat(typeof(item[field]) == 'number' ? item[field].toFixed() : item[field]);
        } else {
          sum += parseFloat(item[field]);
        }
      }
    });
    return sum;
  }

  /**
   * Tính max
   */
  maxField(data, field, dataFormat) {
    let me = this,
      res = null;
    data.forEach(item => {
      let value = item[field];
      if (res == null) {
        res = value;
      } else if (value > res) {
        res = value;
      }
    });
    return res;
  }

  /**
   * Tính min
   */
  minField(data, field, dataFormat) {
    let me = this,
      res = null;
    data.forEach(item => {
      let value = item[field];
      if (res == null) {
        res = value;
      } else if (value < res) {
        res = value;
      }
    });
    return res;
  }

  /**
   * Tính tổng tất cả các dữ liệu theo field
   * @param {String} field: cột
   * @param {Number} dataFormat: kiểu dữ liệu của cột
   * @author NVLAM 24.09.2020
   */
  sumAllField(data, field, dataFormat) {
    let sum = 0;
    if (data && data.length > 0) {
      data.forEach(item => {
        if (item[field]) {
          sum += parseFloat(item[field]); //.toFixed(FormatUtil.getDecimalDigitByFormatType(dataFormat))
        }
      });
      return sum;
    }
  }
  /**
   * Parse dòng tổng ở footer
   * @param {*} data
   * @returns
   * NCPHUOC 26/04/2022
   */
  rowCount(data) {
    const { proxy } = getCurrentInstance();
    if (data) {
      let rowCount = proxy.$ms.format.formatData(data, {
        formatType: proxy.$ms.constant.FormatType.Number,
      });
      let text = proxy.$t('i18nComponent.Grid.FooterRowCount', [rowCount]);
      return text;
    }
    return '';
  }
}
export default new SummaryUtil();
